import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserService } from '@app/core/services/user.service';

/**
 * This directive should be used when there's a content that should be hidden for the read-only user.
 */
@Directive({
  selector: '[pcsHideIfReadonlyUser]'
})
export class HideIfReadonlyUserDirective {
  constructor(private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private userService: UserService) {
    if (!this.userService.isReadonlyUser()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
